const routes = [
  {
    path: '/', redirect: '/home',
  },
  {
    path: '/home', name: 'Home', meta: { title: "主页" }, component: () => import('@/views/HomeView/index.vue')
  },
  {
    path: "/:catchAll(.*)", component: () => import("@/views/Error/index.vue"), meta: { title: "404" },
  },
]

export default routes